export const createColleague = {
    text1: "Veuillez indiquer quelques informations sur ce nouveau praticien."
}